const config = require('../config'); const apiConfig = require('../api-config');
const apiFactory = require('../resources/assets-common/api-factory');
const serviceFactory = require('../resources/assets-common/service-factory');
const routeAdderFactory = require('../resources/assets-common/route-adder-factory');

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/various/${apiConfig.apiversion}/`,
    authToken: config.authToken,
    assetCategory: '9',
    positionsUrl: 'various-positions',
    transactionsUrl: 'various-transactions',
    valueMovementUrl: 'various-value-movement',
  });

  const service = serviceFactory({
    api,
  });

  return routeAdderFactory({ assetType: 'various', service });
}

module.exports = addRoutes;
